import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const menuDefaultVariants = {
  "iconPlacement": "left",
  "multiSelectType": "checkbox"
}
const menuCompoundVariants = []

const menuSlotNames = [
  [
    "wrapper",
    "menu__wrapper"
  ],
  [
    "sectionTitle",
    "menu__sectionTitle"
  ],
  [
    "menuItem",
    "menu__menuItem"
  ],
  [
    "menuLabel",
    "menu__menuLabel"
  ],
  [
    "menuDescription",
    "menu__menuDescription"
  ],
  [
    "parentLabel",
    "menu__parentLabel"
  ],
  [
    "multiLevelIcon",
    "menu__multiLevelIcon"
  ],
  [
    "dividerSection",
    "menu__dividerSection"
  ],
  [
    "spacerSection",
    "menu__spacerSection"
  ],
  [
    "wrapperInner",
    "menu__wrapperInner"
  ],
  [
    "iconSection",
    "menu__iconSection"
  ],
  [
    "toggleMenu",
    "menu__toggleMenu"
  ]
]
const menuSlotFns = /* @__PURE__ */ menuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, menuDefaultVariants, getSlotCompoundVariant(menuCompoundVariants, slotName))])

const menuFn = memo((props = {}) => {
  return Object.fromEntries(menuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const menuVariantKeys = [
  "iconPlacement",
  "multiSelectType"
]
const getVariantProps = (variants) => ({ ...menuDefaultVariants, ...compact(variants) })

export const menu = /* @__PURE__ */ Object.assign(menuFn, {
  __recipe__: false,
  __name__: 'menu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: menuVariantKeys,
  variantMap: {
  "iconPlacement": [
    "left",
    "right"
  ],
  "multiSelectType": [
    "toggle",
    "checkbox"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, menuVariantKeys)
  },
  getVariantProps
})